








import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { MetaInfo } from 'vue-meta';

import CookieConsent from '@/components/common/CookieConsent.vue';

import LocaleMixin from '@/mixins/locale';

@Component({
  metaInfo(this: App): MetaInfo {
    return {
      title: 'Game Portal',
      htmlAttrs: {
        lang: this.locale,
      },
    };
  },
  components: { CookieConsent },
})
export default class App extends mixins(LocaleMixin) {}
